<template>

  <div class="mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
       Compliances
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200">
        Create your contact center's complainces to measure your agents complaince. 
      </h1>
      
    </div>

    <div class="flex">
      

      <label class="input input-bordered flex items-center mr-2" style="width:330px">
        <input type="text" v-model="searchValue" class="grow" placeholder="Search" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-4 w-4 opacity-70">
          <path fill-rule="evenodd"
            d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            clip-rule="evenodd" />
        </svg>
      </label>
      
      
    </div>
  </div>
  
  <div class="mt-6 px-4">
    <ThemeOnly theme="modern" :invert="true">
      <div
        class="overflow-x-auto text-align card shadow bg-white dark:bg-gray-800 w-full rounded-md p-3 border dark:border-gray-700 flex"
        style="border-radius: 10px; width:98%;height: 70vh;">
        <EasyDataTable :headers="headers" :items="customActionsDebug" buttons-pagination :search-field="searchFields"
    :search-value="searchValue">
    
     
      <template #item-actions="{ actions }">
        <div v-for="action in actions" class="" style="margin-top:2%;margin-bottom: 2%;">
          <span v-if="action.actionType.length >= 0" class="text-sm text-gray-500 badge badge-outline" style="margin-bottom:0.1%;">{{ action.actionType }}</span>
        </div>
      </template>
      <template #item-options>
        <button @click="isDeleteModalOpen=true" class="hover:text-red-900 p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-translation-id="deleteButton">Delete</button>
      </template>
      <template #loading>
        <ModernLoader />
      </template>
    </EasyDataTable>
      </div>
    </ThemeOnly>
  </div>




  <it-modal v-model="isDeleteModalOpen">
  <div class="p-4">
    <h2 class="text-2xl font-bold mb-4" data-translation-id="addNewProfileHeader">Are you sure?</h2>
  Are you sure you want to delete this Compliance?

  <div class="flex justify-end mt-6">
            <button @click="isDeleteModalOpen=false" type="button" class="mr-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" data-translation-id="cancelButton">
                Cancel
            </button>
            <button @click="isDeleteModalOpen=false" data-translation-id="addProfileButton" type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Delete
            </button>
        </div>
  </div>
  
</it-modal>

</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>
<script setup>
import { ref, onMounted } from 'vue';
import { isDefinedAndNotEmpty } from '../../isDefinedAndNotEmpty.js';
import ModernLoader from '@/components/ModernLoader.vue';
import ThemeOnly from '@/components/ThemeOnly.vue';

const isDeleteModalOpen = ref(false);
const searchFields = ["actionName","description"];
const searchValue = ref("");


const headers = [
  { text: "ID", value: "complianceID", sortable: true },
  { text: "Compliance Name", value: "complianceName" },
  { text: "Description", value: "description" },
  {text: "Options",value:"options"}

];





let customActionsDebug = ref([
    {
        "complianceID": "2",
        "complianceName": "מח\"ט",
        "description": "מפקד חטיבה",
    },
    {
        "complianceID": "2",
        "complianceName": "מח\"ט",
        "description": "מפקד חטיבה",
    },{
        "complianceID": "2",
        "complianceName": "מח\"ט",
        "description": "מפקד חטיבה",
    },{
        "complianceID": "2",
        "complianceName": "מח\"ט",
        "description": "מפקד חטיבה",
    },{
        "complianceID": "2",
        "complianceName": "מח\"ט",
        "description": "מפקד חטיבה",
    }
]);



onMounted(() => {
  
  loadStyle(`
.vue3-easy-data-table {
  height: 95%;
}
.sp-trigger-container.sp-opened{
  box-shadow:none;
}
  .dp__main{
    width:262px;
    height:100%;
  }
    .sp-trigger-container .sp-trigger.sp-chips{
    max-height: 1.8rem;
    overflow: auto;
    }
    .sp-trigger-container{
      height:3rem;
    }
    .dp__main input {
     padding-left:17%;
    border-color: #dadcdf;
    flex-shrink: 1;
    appearance: none;
    height: 3rem;
    width:260px;
    font-size: 1rem;
    line-height: 2;
    line-height: 1.5rem;
    border-radius: var(--rounded-btn, .5rem);
    border-width: 1px;
    
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
    }

    .multiselect{
      height:3rem;
      width: 180px;
      margin-right:1%;
    }
  `);

 
})
function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet != null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}




</script>
